import React from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomTabset from "../Components/CustomTabset/CustomTabset.jsx";
import {globals} from "../Components/Globals/Globals.js";
import {loadAwards} from "../redux/awardSlice.js";
import { Button } from "reactstrap";

// reactstrap components
import {Container, Row} from "reactstrap";

// core components
import AwardsRawTableDataSync from "../Components/AwardsRawTableDataSync/AwardsRawTableDataSync";

const AdminAwardsView = (props) => {
  const dispatch = useDispatch();

  // Get the stats from the store
  const {awardsItems, loadAwards_result} = useSelector((state) => state.awards)
  
  React.useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    let isMounted = true

    // If status is !loading, then fetch stats data from the API
    if (loadAwards_result.status === 'idle'){
      if (globals.parameters.redux_debugging) alert("loading awards")
      dispatch(loadAwards());
    }

    if (loadAwards_result.status === 'loading'){
      if (globals.parameters.redux_debugging) alert("loading awards...")
    }

    // If status is !loading, then fetch stats data from the API
    if (loadAwards_result.status === 'succeeded'){
      if (globals.parameters.redux_debugging) alert("awards successfully loaded")
        console.log("AdminAwardsView -> awardsItems ", awardsItems)
    }

    // Cleanup function
    return () => {
      isMounted = false
    }
  }, [loadAwards_result, dispatch]);


  return (    
        <div className="wrapper">
          <div className="main">
            <div className="section">
              <Container>
                {/** Search toolbar */}
                <CustomTabset activeTabset={"awards"}/>
                <Row>
                  <div>
                      {awardsItems  &&
                      <AwardsRawTableDataSync
                        awards_list = {awardsItems}
                        />}                 
                </div>
                </Row> 
              </Container>
            </div>
          </div>
        </div>
  );
}

export default AdminAwardsView;
